"use client";
import React, { useEffect, useRef, useState } from "react";
import Link from "next/link";
import Image from "next/image";
import Logo from "../../../../public/logo.png";
import { usePathname } from "next/navigation";
import { BiChevronDown } from "react-icons/bi";
import { RiMenu4Line } from "react-icons/ri";
import { DropdownItems, MenuItems } from "../MenuItem";

const DesktopHeader = () => {
  const pathname = usePathname();
  const [openDropdownId, setOpenDropdownId] = useState<number | null>(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const submenuRefs = useRef<{ [key: number]: HTMLUListElement | null }>({});
  const menuRef = useRef<HTMLLIElement>(null);

  const handleMouseEnter = (id: number) => setOpenDropdownId(id);
  const handleMouseLeave = () => setOpenDropdownId(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 border-b ${
        isScrolled
          ? "bg-white shadow-md border-gray-200"
          : "bg-transparent border-gray-50/20"
      }`}
    >
      <div className="container mx-auto flex items-center justify-between py-4">
        {/* Logo */}
        <Link href="/" className="w-[15%]">
          <Image
            src={Logo}
            alt="logo"
            className={`w-full transition-all duration-300 custome-drop-shadow ${
              isScrolled ? "scale-90" : "scale-100"
            }`}
          />
        </Link>

        {/* Navigation Menu */}
        <ul className="flex gap-8 items-center relative">
          {MenuItems.map((item) => (
            <li
              key={item.id}
              className="relative group"
              onMouseEnter={() => handleMouseEnter(+item.id)}
              onMouseLeave={handleMouseLeave}
            >
              <Link
                href={item.href ?? "/error"}
                className={`flex items-center gap-1 text-sm font-semibold transition ${
                  pathname === item.href
                    ? "!text-red-400"
                    : isScrolled
                    ? "text-[#282930] hover:text-primary"
                    : "!text-white hover:text-primary"
                }`}
              >
                {item.name}
                {item.submenu && <BiChevronDown size={20} />}
              </Link>

              {item.submenu && (
                <ul
                  ref={(el) => {
                    submenuRefs.current[+item.id] = el;
                  }}
                  className={`absolute left-0 top-[65%] w-[250px] mt-2 bg-white shadow-md rounded flex flex-col gap-2 z-40 py-3 transition-all duration-300 origin-top transform ${
                    openDropdownId === +item.id
                      ? "opacity-100 scale-100 translate-y-0 pointer-events-auto"
                      : "opacity-0 scale-95 -translate-y-2 pointer-events-none"
                  }`}
                >
                  {item.submenu.map((sub) => (
                    <React.Fragment key={sub.id}>
                      <li className="hover:text-blue-600 font-normal px-4 group">
                        <Link href={sub.href} className="text-sm">
                          {sub.name}
                        </Link>
                      </li>
                      <li className="last:hidden opacity-20">
                        <hr />
                      </li>
                    </React.Fragment>
                  ))}
                </ul>
              )}
            </li>
          ))}

          {/* Right Icon Dropdown */}
          <li
            className="relative cursor-pointer group"
            ref={menuRef}
            onMouseEnter={() => handleMouseEnter(999)}
            onMouseLeave={handleMouseLeave}
          >
            <RiMenu4Line
              size={25}
              className={`transition ${
                isScrolled ? "text-[#282930]" : "text-white"
              } hover:text-primary`}
            />

            <ul
              className={`absolute right-0 top-[95%] w-[150px] bg-white/90 shadow-md rounded flex flex-col gap-2 z-40 py-2 transition-all duration-300 origin-top transform ${
                openDropdownId === 999
                  ? "opacity-100 scale-100 translate-y-0 pointer-events-auto"
                  : "opacity-0 scale-95 -translate-y-2 pointer-events-none"
              }`}
            >
              {DropdownItems.map((item) => (
                <React.Fragment key={item.id}>
                  <li>
                    <Link
                      href={item.href ?? "/error"}
                      className="block px-4 text-sm text-black hover:text-blue-600"
                    >
                      {item.name}
                    </Link>
                  </li>
                  <li className="last:hidden opacity-20">
                    <hr />
                  </li>
                </React.Fragment>
              ))}
            </ul>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default DesktopHeader;
